module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"DeleteSelected":"Delete selected","DeleteAll":"Delete all","MarkRead":"Mark read"},"vi":{"DeleteSelected":"Xoá mục đã chọn","DeleteAll":"Xoá tất cả","MarkRead":"Đánh dấu đã đọc"}}')
  delete Component.options._Ctor
}
